import vue from 'vue';
import GenericTable from 'src/components/GenericTable/GenericTable.vue';
vue.component('GenericTable', GenericTable);
